document.querySelector('.shopify-section-menu-drawer').addEventListener('click', (event) => {
  const clickEventPath = event.composedPath().slice(0, -2);

  for (const element of clickEventPath) {
    const clickAction = element?.getAttribute('data-click-action');

    if (clickAction === 'close-menu-drawer') {
      closeMenuDrawerHandler(element);
      break;
    } else if (clickAction === 'open-cart-drawer') {
      closeMenuDrawerHandler(element);
      openCartDrawerHandler();
      window.mx.hideGorgiasButton();
      break;
    } else if (clickAction === 'toggle-child-link-list') {
      toggleChildLinkListHandler(element);
    } else if (clickAction === 'open-chat-bubble') {
      openChatBubble(element);
    }
  }
});

function closeMenuDrawerHandler(closeButton) {
  closeButton.closest('.shopify-section-menu-drawer').querySelector('.mx-menu-drawer').removeAttribute('data-open');
  document.documentElement.removeAttribute('data-locked');
  window.scrollTo(0, -1 * parseInt(document.documentElement.style.top));
  document.documentElement.style.top = null;
  document.documentElement.style.scrollBehavior = null;
}

function toggleChildLinkListHandler(element) {
  const expandButton = element.parentElement.querySelector('.menu-expand-container');
  const childLinkListContainer = element.parentElement.querySelector('.child-link-list-container');

  childLinkListContainer.hasAttribute('data-open')
    ? (element.removeAttribute('data-active'), expandButton.removeAttribute('data-active'))
    : element.setAttribute('data-active', '');

  childLinkListContainer.hasAttribute('data-open')
    ? childLinkListContainer.removeAttribute('data-open')
    : childLinkListContainer.setAttribute('data-open', '');
}

function openChatBubble(menuLink) {
  closeMenuDrawerHandler(menuLink);

  const bubbleButton = document?.querySelector('#chat-button');
  if (!bubbleButton) return;

  GorgiasChat.open();
}
